import {
  Component,
  OnInit,
  AfterContentInit,
  ContentChildren,
  QueryList,
  Directive,
  ElementRef,
  Output,
  EventEmitter,
  Input
} from '@angular/core';
import { ViewStackViewComponent } from './view-stack-view/view-stack-view.component';

export type ViewStackLookUp = {
  [key: string]: ViewStackViewComponent;
}
@Component({
  selector: 'app-view-stack',
  templateUrl: './view-stack.component.html',
  styleUrls: ['./view-stack.component.scss']
})

export class ViewStackComponent implements OnInit, AfterContentInit {
  @ContentChildren(ViewStackViewComponent, { descendants: false }) children !: QueryList<ViewStackViewComponent>;
  @Output() ready = new EventEmitter<any>();

  private childMap: ViewStackLookUp = {};
  private displayedView = '';
  private initialized: boolean = false;
  public value: any;
  get selectedView(): string {
    return this.displayedView;
  }
  private isVertical = false;
  @Input() set vertical(isVertical: string) {
    this.isVertical = true;
  }
  @Input()
  set viewName(name: string) {
    if (this.initialized === false) {
      this.displayedView = name;
      return;
    }
    if (name === '-all-') {
      this.ShowAllViews();
      return;
    }
    this.SetView(name);
  }
  @Output() viewNameChange: EventEmitter<string> = new EventEmitter<string>();

  get currentView(): ViewStackViewComponent {
    return this.childMap[this.displayedView];
  }
  get element(): ElementRef {
    return this.domNode;
  }

  constructor(private domNode: ElementRef) { }

  ngOnInit() {
    this.domNode.nativeElement.classList.toggle('view-stack', true);
  }
  ngAfterContentInit() {

    let isFirst = true;
    let firstChild: ViewStackViewComponent | null = null;
    let initView: string = this.displayedView;

    this.children.forEach((child: ViewStackViewComponent, index: number, src: ViewStackViewComponent[]) => {
      if (isFirst) {
        firstChild = child;
        if ((initView === '') && !!firstChild) {
          initView = !!firstChild.viewName ? firstChild.viewName : '';
        }
      }
      child.ToggleActive(child.viewName === initView);

      isFirst = false;
      if (!!child.viewName) {
        this.childMap[child.viewName] = child;
      }

    });
    this.initialized = true;
    if (this.displayedView === '-all-') {
      this.ShowAllViews();
    } else if (this.displayedView !== '') {
      this.SetView(this.displayedView);
    } else if (firstChild !== null) {
      this.SetView(initView);
    }
    this.ready.emit(this);

    /*if (this.selectedView) {
      this.SetView(this.selectedView);
    }*/
  }
  SetView(viewName: string) {

    if (viewName === '') {
      viewName = 'none';
    }
    if (viewName === 'none') {
      if (!!this.displayedView && !(this.displayedView === 'none')) {
        (this.childMap[this.displayedView] as ViewStackViewComponent).ToggleActive(false);
      }
      this.domNode.nativeElement.classList.toggle('hidden', true);
      return;
    }
    this.domNode.nativeElement.classList.toggle('hidden', false);
    if (!this.childMap.hasOwnProperty(viewName)) {
      // this.displayedView = viewName;
      return;
    }
    if (this.displayedView) {
      (this.childMap[this.displayedView] as ViewStackViewComponent).ToggleActive(false);
    }
    this.displayedView = viewName;
    (this.childMap[viewName] as ViewStackViewComponent).ToggleActive(true);

    this.viewNameChange.emit(this.displayedView);
  }
  ShowAllViews() {
    for (const child of Object.values(this.childMap)) {
      child.ToggleActive(true);
    }
  }
}
